import styled, { css } from 'styled-components';

export const backendPalette = {
  yellow: '#e0a15e',
  green: '#658963',
  red: '#a64c44',
  grey: '#969696',
  black: '#1a1a1a',
} as const;

const panelBase = css`
  position: relative;
  border-radius: 18px;
  color: ${backendPalette.black};
  overflow: hidden;
`;

const surfaceNoise = css`
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
      linear-gradient(120deg, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0) 35%),
      linear-gradient(20deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0) 40%);
    opacity: 0.45;
  }
`;

export const LongRedPanel = styled.section`
  ${panelBase};
  ${surfaceNoise};
  background: ${backendPalette.red};
  padding: 14px;
`;

export const FullWidthYellowPanel = styled.section`
  ${panelBase};
  ${surfaceNoise};
  background: ${backendPalette.yellow};
  padding: 14px;
`;

export const SmallGreenPanel = styled.section`
  ${panelBase};
  ${surfaceNoise};
  background: ${backendPalette.green};
  padding: 12px;
`;

export const SmallGrayPanel = styled.section`
  ${panelBase};
  ${surfaceNoise};
  background: ${backendPalette.grey};
  padding: 12px;
`;

export const PanelTitle = styled.div`
  position: relative;
  z-index: 1;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 700;
  color: rgba(26, 26, 26, 0.82);
`;

export const PanelValue = styled.div`
  position: relative;
  z-index: 1;
  font-size: 1rem;
  line-height: 1.25;
  font-weight: 800;
  color: ${backendPalette.black};
`;

export const PanelSubtext = styled.div`
  position: relative;
  z-index: 1;
  font-size: 0.8rem;
  color: rgba(26, 26, 26, 0.78);
`;

export const PanelAccent = styled.span`
  color: ${backendPalette.red};
  font-weight: 800;
`;
